import { render, staticRenderFns } from "./uiText.vue?vue&type=template&id=113678bc&scoped=true"
import script from "./uiText.vue?vue&type=script&lang=js"
export * from "./uiText.vue?vue&type=script&lang=js"
import style0 from "./uiText.vue?vue&type=style&index=0&id=113678bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113678bc",
  null
  
)

export default component.exports